<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="justify-center mt-3">
            <v-col cols="3">
              <v-text-field
                label="Formação"
                v-model="form.filters.Formacao"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Solicitante"
                v-model="form.filters.Solicitante"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <sigfoco-date-picker
              :cols="2"
              label="Data de Solicitação"
              v-model="form.filters.dataSolicitacao"
              removeIcon
              outlined
              dense
            ></sigfoco-date-picker>
            <sigfoco-date-picker
              :cols="2"
              label="Data de Realização"
              v-model="form.filters.dataRealizacao"
              removeIcon
              outlined
              dense
            ></sigfoco-date-picker>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarFormacao()"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm()"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="headers"
          :items="form.lists.listFormacoes"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.solicitante`]="{ item }">
            {{ item.solicitante }}
          </template>
          <template v-slot:[`item.dataSolicitacao`]="{ item }">
            {{ $formatarData(item.dataSolicitacao) }}
          </template>
          <template v-slot:[`item.dataRealizacao`]="{ item }">
            {{ $formatarData(item.dataRealizacao) }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sigfoco-tooltip
              text="Visualizar"
              icon="mdi-eye-outline"
              small
              @click="openDialogVisualizarFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Aprovar"
              icon="mdi-check-circle-outline"
              small
              @click="openDialogManterFormacao(item)"
            ></sigfoco-tooltip>             
            <sigfoco-tooltip
              text="Reprovar"
              icon="mdi-close-circle-outline"
              small
              @click="openDialogJustificativaReprovacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              v-if="item.motivoReagendamento != null && item.statusId == statusFormacaoEnum.AGUARDANDO_APROVACAO_REAGENDAMENTO"
              text="Aprovar reagendamento"
              icon="mdi-calendar-edit"
              small
              @click="openDialogAprovarReprovarReagendarFormacao(item)"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Baixar Solicitação de Formação"
              icon="mdi-arrow-down"
              small
              @click="baixarRelatorioPdf(item)"
            ></sigfoco-tooltip>
          </template>
        </v-data-table>
      </v-container>
      <CadastrarFormacaoDialog
        v-if="dialogManterFormacao.visible"
        :visible="dialogManterFormacao.visible"
        :content="dialogManterFormacao.content"
        :edit="dialogManterFormacao.edit"
        @onClose="fecharDialogManterFormacao"
        @onSave="buscarFormacao()"
      ></CadastrarFormacaoDialog>
      <JustificativaReprovacaoDialog 
        v-if="dialogJustificativaReprovacao.visible"
        :visible="dialogJustificativaReprovacao.visible"
        :content="dialogJustificativaReprovacao.content"
        :edit="dialogJustificativaReprovacao.edit"
        @onClose="dialogJustificativaReprovacao.close()"
        @onReprove="buscarFormacao()"
      ></JustificativaReprovacaoDialog>
      <AprovarReprovarReagendarFormacaoDialog 
        v-if="dialogAprovarReprovarReagendarFormacao.visible"
        :visible="dialogAprovarReprovarReagendarFormacao.visible"
        :content="dialogAprovarReprovarReagendarFormacao.content"
        :edit="dialogAprovarReprovarReagendarFormacao.edit"
        @onClose="dialogAprovarReprovarReagendarFormacao.close()"
        @onAprove="buscarFormacao()"
      ></AprovarReprovarReagendarFormacaoDialog>
    </div>
  </template>
  
  <script>
  import { Formacao } from '~/commons/classes/formacao';
  import { Dialog } from "~/commons/classes/dialog";
  import ManterFormacaoService from '~/services/manter-formacao.service';
  import CadastrarFormacaoDialog from "./dialogs/CadastroFormacao.vue";
  import JustificativaReprovacaoDialog from "./dialogs/JustificativaReprovacao.vue";
  import AprovarReprovarReagendarFormacaoDialog from "./dialogs/AprovarReprovarReagendarFormacao.vue";
  import statusFormacaoEnum from "~/commons/enums/status-formacao.enum";


  import { globalStore }from "~/mixins/global-formacao.mixin";
  export default {
    name: "ManterAprovacaoSolicitacaoView",
    mixins: [ManterFormacaoService],
    components: {
      CadastrarFormacaoDialog,
      JustificativaReprovacaoDialog,
      AprovarReprovarReagendarFormacaoDialog
    },
    data: () => ({
      dialogManterFormacao: Dialog.Build(),
      dialogVisualizarFormacao: Dialog.Build(),
      dialogJustificativaReprovacao: Dialog.Build(),
      dialogAprovarReprovarReagendarFormacao: Dialog.Build(),
      form:{
        filters: {
            Formacao: null,
            Solicitante: null,
            dataSolicitacao: null,
            dataRealizacao: null,
        },
        lists: {
          listFormacoes: [],
        }
      },
      headers: [
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Solicitante", align: "center", value: "solicitante" },
        { text: "Data de Solicitação", align: "center", value: "dataSolicitacao" },
        { text: "Data de Realização", align: "center", value: "dataRealizacao" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
      statusFormacaoEnum
    }),
    methods: {
      fecharDialogManterFormacao() {
        this.dialogManterFormacao.close();
        globalStore.limpar();
      },
      buscarFormacao() {
        // Removido por solicitacao do cliente: Chamado 71263
        // https://gestaoprojetosggti.educacao.pe.gov.br/issues/49750
        // if(!this.$user.isAdmGre){
        //   return this.$notifyError("Perfil não autorizado para acessar esta funcionalidade.")
        // }
        this.$buscarFormacaoAprovacao({ params: this.form.filters }).then(
          ({ data }) => this.form.lists.listFormacoes = data.itens
        )
      },
      openDialogManterFormacao(formacao) {
        globalStore.limpar();

        if (formacao) {
          globalStore.setFormacaoId(formacao.id);
          Promise.all([
              this.$visualizarAbaPlanoDeTrabalho(formacao.id),
              this.$visualizarAbaProgramacao(formacao.id),
          ]).then(([abaPlanoDeTrabalhoResp, abaDadosProgramacao]) => {
              const dadosPlanoDeTrabalho = abaPlanoDeTrabalhoResp.data.resposta;
              const dadosProgramacao = abaDadosProgramacao.data.lista;

              globalStore.setDadosPlanoDeTrabalho(dadosPlanoDeTrabalho);
              globalStore.setSituacaoId(dadosPlanoDeTrabalho.situacaoId);
              globalStore.setDadosProgramacao(dadosProgramacao);

              this.dialogManterFormacao.open(new Formacao(dadosPlanoDeTrabalho), true);
          });
        } else {
          globalStore.setViewMode(false);
          globalStore.setReenviarSolicitacao(false);
          this.dialogManterFormacao.open(Formacao.Build());
        }
      },
      openDialogVisualizarFormacao(formacao) {
        if (formacao) {
            globalStore.limpar();
            globalStore.setFormacaoId(formacao.id);
            globalStore.setViewMode(true);
            this.$nextTick(() => { 
                
                Promise.all([
                    this.$visualizarAbaPlanoDeTrabalho(formacao.id),
                ]).then(([abaPlanoDeTrabalhoResp]) => {
                    const dadosPlanoDeTrabalho = abaPlanoDeTrabalhoResp.data.resposta;
                    globalStore.setDadosPlanoDeTrabalho(dadosPlanoDeTrabalho);

                    this.dialogManterFormacao.open(new Formacao(dadosPlanoDeTrabalho), true, true);
                });
            });
          }
      },
      openDialogJustificativaReprovacao(formacao, isViewMode = false) {
        formacao.tipoReprovacao = 6;
        this.dialogJustificativaReprovacao.open(formacao, isViewMode);
      },
      openDialogAprovarReprovarReagendarFormacao(formacao) {
        formacao.isConsolidacao = false;
        this.dialogAprovarReprovarReagendarFormacao.open(formacao);
      },
      resetForm() {
        this.$resetForm();
        this.form.filters = {};
        this.form.lists.listFormacoes = [];
      },
      async baixarRelatorioPdf(formacao) {
        this.showPageLoading();
        try {
          const { data } = await this.$obterRelatorioPDFSolicitacaoFormacao(this.$montarParamsFilters({id: formacao.id}));
          const url = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "SIGFOCO.RelatórioSolicitacaoFormacao.pdf");
          document.body.appendChild(link);
          link.click();
          this.$notifySuccess("Operação realizada com sucesso.");
          } finally {
          this.hidePageLoading();
        }
      },
    },
  }
  </script>